import type { VertiNodeLevel } from "../VertiNodeLevel.js";
import type { VertiNodeLocalizedString } from "../VertiNodeLocale.js";

export function getVertiNodeLevelDetailPath(vertiNodeLevel: VertiNodeLevel): VertiNodeLocalizedString {
	return vertiNodeLevel.urlSlug;
}
